import { create } from 'zustand';
import { apiService } from '../services/api';
import type { Profile } from '../types';

interface ProfileState {
  profiles: Profile[];
  loading: boolean;
  error: string | null;
  fetchProfiles: () => Promise<void>;
}

export const useProfileStore = create<ProfileState>((set, get) => ({
  profiles: [],
  loading: false,
  error: null,
  fetchProfiles: async () => {
    // Evita requisições duplicadas se já está carregando ou já tem dados
    const { loading, profiles } = get();
    if (loading || profiles.length > 0) return;
    
    set({ loading: true, error: null });
    try {
      const profiles = await apiService.getContentProfiles();
      set({ profiles, loading: false });
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
      set({ error: errorMessage, loading: false });
    }
  },
})); 